// ============================================
// PROGRESS STEPS COMPONENT
// ============================================

import { Check } from 'lucide-react';
import styles from './ProgressSteps.module.css';

interface Step {
  id: number;
  title: string;
  description: string;
}

interface ProgressStepsProps {
  steps: Step[];
  currentStep: number;
  onStepClick?: (step: number) => void;
}

export function ProgressSteps({
  steps,
  currentStep,
  onStepClick,
}: ProgressStepsProps) {
  return (
    <div className={styles.container}>
      <div className={styles.steps}>
        {steps.map((step, index) => {
          const isCompleted = step.id < currentStep;
          const isCurrent = step.id === currentStep;
          const isClickable = onStepClick && step.id < currentStep;

          return (
            <div key={step.id} className={styles.stepWrapper}>
              {/* Connector Line */}
              {index > 0 && (
                <div
                  className={`${styles.connector} ${
                    isCompleted || isCurrent ? styles.connectorActive : ''
                  }`}
                />
              )}

              {/* Step Circle */}
              <button
                type="button"
                className={`${styles.step} ${
                  isCompleted
                    ? styles.completed
                    : isCurrent
                    ? styles.current
                    : styles.upcoming
                }`}
                onClick={() => isClickable && onStepClick(step.id)}
                disabled={!isClickable}
              >
                {isCompleted ? (
                  <Check size={16} strokeWidth={3} />
                ) : (
                  <span>{step.id}</span>
                )}
              </button>

              {/* Step Label */}
              <div className={styles.labelWrapper}>
                <span
                  className={`${styles.title} ${
                    isCurrent ? styles.titleCurrent : ''
                  }`}
                >
                  {step.title}
                </span>
                <span className={styles.description}>{step.description}</span>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
